import React from 'react'
import {useSelector} from "react-redux";

export default function ImageMapRedirect({onDataChanged, value}) {
  const imageMapRedirectData = useSelector((state) => state.imageMapRedirectData)

  return <div>
    <hr/>
    <h5 className="hotspot-setting-header">Image-Map Redirect</h5>
    <div className="hotspot-setting-info">
      Redirects the user to a specific ImageMap
    </div>
    <div className="form-group">
      <select className="form-control"
              id="hotspotType"
              value={value}
              onChange={onDataChanged}>
        <option/>
        {imageMapRedirectData.map(imageMapData => {
          return <option key={"redir" + imageMapData.id} value={imageMapData.id}>{imageMapData.title}</option>
        })}
      </select>
    </div>
  </div>
}
